import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Footer() {
  const [company, setCompany] = useState(null);
  useEffect(() => { api.get("/company").then((r) => setCompany(r.data)).catch(() => {}); }, []);

  const legal = [
    ["Impressum", "/impressum"], ["AGB", "/agb"], ["Widerruf", "/widerruf"], ["Cookies", "/cookies"],
  ];
  return (
    <footer data-testid="footer" className="relative z-10 bg-[#050505] border-t border-white/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16">
          <div className="lg:col-span-5">
            <Link to="/" className="font-display text-3xl text-white flex items-center gap-2">
              <span className="inline-block w-2 h-2 rounded-full bg-white" /> G-Repair
            </Link>
            <p className="text-[#999] mt-5 max-w-sm leading-relaxed">Dein Spezialist für iPhone Display-Reparatur und Akkutausch. Deutschlandweiter Einsendeservice mit 6 Monaten Garantie auf Original-OLED-Displays.</p>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#888] mb-5">Kontakt{company?.show_address ? " & Adresse" : ""}</p>
            <ul className="space-y-3 text-[#ccc] text-sm" data-testid="footer-contact">
              <li><a href={`mailto:${company?.email || "info@g-repair.de"}`} className="hover:text-white transition-colors">{company?.email || "info@g-repair.de"}</a></li>
              {company?.show_address && (
                <li data-testid="footer-address">{company.name}{company.owner ? ` · ${company.owner}` : ""}<br />{company.street}, {company.zip} {company.city}</li>
              )}
            </ul>
          </div>
          <div className="lg:col-span-4">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#888] mb-5">Rechtliches</p>
            <ul className="space-y-3 text-[#ccc] text-sm">
              {legal.map(([l, to]) => (
                <li key={to}><Link to={to} data-testid={`footer-${to.slice(1)}`} className="hover:text-white transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-white/10">
          <p className="font-mono text-xs text-[#666]">© {new Date().getFullYear()} G-Repair. Alle Rechte vorbehalten.</p>
          <Link to="/admin/login" data-testid="admin-link" className="font-mono text-xs text-[#555] hover:text-[#999] transition-colors">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
